import { Icon } from '@doordash/design-language'
import { i18nKeys } from 'translationTypes'
import { IStep } from '../Step'

export const ABN_LOOKUP_URL = 'https://abr.business.gov.au/'

export const config: IStep = {
  instructions: [
    i18nKeys.backgroundCheck__abnLookup__description,
    i18nKeys.backgroundCheck__abnLookup__requirementMain,
  ],
  bulletsWithIcon: [
    {
      text: i18nKeys.backgroundCheck__abnLookup__requirement1,
      icon: Icon.Types.PersonUserLine,
    },
    {
      text: i18nKeys.backgroundCheck__abnLookup__requirement2,
      icon: Icon.Types.ReceiptLine,
    },
  ],
}
